import React, { useState, useEffect } from "react";
import { JobService } from "../../../../../services/JobService";
import TreeView from "react-treeview";
import $ from "jquery";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import {
  Row,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";
import { getEnumLists } from "../../../../../services/MetadataService";

const Certification = (props) => {
  var { id } = useParams();
  const [modalRight, setModalRight] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCertifications, setSelectedCertifications] = useState([]);
  const [filteredCertifications, setFilteredCertifications] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [languageshow, setlanguageShow] = useState(true);
  const [buttonShow, setButtonShow] = useState(true);
  const [scategories, setSCategories] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedCertificationIds, setSelectedCertificationIds] = useState([]);
  const [certificationId, setCertificationId] = useState("");
  const [certificationName, setCertificationName] = useState("");
  const [jobSkillLevels, setJobSkillLevels] = useState([]);
  const [treeview, setTreeview] = useState(true);
  const [jobStatus, setJobStatus] = useState("");
  useEffect(() => {
    getJobEnums();
    getTotalCertificationsList();
    if (id != 0) {
      getJobDetails(id);
      getTotalReqCertificationsList();
    }
  }, []);
  const getJobDetails = (jobId) => {
    var jobDetails = props.jobDetails;
    if (jobDetails != null) {
      if (jobDetails.jobStatus !== null || jobDetails.jobStatus !== "") {
        setJobStatus(jobDetails.jobStatus.key);
      }
    }
  };
  const getJobEnums = () => {
    getEnumLists().then((response) => {
      try {
        if (response !== null) {
          let jobSkillLevels = response.jobSkillLevels;
          const skillLevel = jobSkillLevels.reverse();
          setJobSkillLevels(skillLevel);          
        }       
      } catch (err) {}
    });
  };

  const getTotalCertificationsList = () => {
    JobService.getcertificationService().then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          var skillDetails = response.data;
          if (skillDetails != null) {
            const indlist = skillDetails.indlist;

            if (indlist.length > 0) {
              indlist.map((industrydetails, index) => {
                industrydetails.categories.length > 0 &&
                  industrydetails.categories.map((category, index) => {
                    category.skills.length > 0 &&
                      category.skills.map((skill, indexval) => {
                        category.skills[indexval].skillLevel = "";
                      });
                  });
              });
              setCategories(indlist);
              setFilteredCertifications(indlist);
            } else {
              setCategories([]);
              setFilteredCertifications([]);
            }
          }
        }
      } catch (err) {}
    });
  };

  const getTotalReqCertificationsList = () => {
    JobService.getReqCertificationsService(id).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data != null) {
            setSCategories(response.data.skills);
            // setSelectedCertifications(response.data.skills);
          } else {
          }
        }
      } catch (err) {}
    });
  };

  const handleCheck = (event, softSkills, categoryId) => {
    var updatedList = [...selectedSkills];
    if (event.target.checked) {
      updatedList.push(softSkills.skillId);
      const isFound = selectedCertifications.some((element) => {
        if (element.skillId === selectedCertifications.skillId) {
          return true;
        }
        return false;
      });
      if (isFound) {
      } else {
        selectedCertifications.push({
          skillType: "CERTIFICATION",
          skillId: softSkills.skillId,
          skillLevel: $("#" + softSkills.skillId + "_skillLevel").val(),
          categoryId: categoryId,
        });
        selectedCertificationIds.push({
          skillId: softSkills.skillId,
        });
      }
    } else {
      for (var i = 0; i < selectedCertifications.length; i++) {
        if (selectedCertifications[i].skillId === softSkills.skillId) {
          selectedCertifications.splice(i, 1);
          selectedCertificationIds.splice(i, 1);
          break;
        }
      }
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i] === softSkills.skillId) {
          updatedList.splice(i, 1);
        }
      }
    }
    setSelectedCertifications(selectedCertifications);
    setSelectedSkills(updatedList);
  };

  function handleSoftSkillLevel(e, id, categoryId) {
    for (var i = 0; i < selectedCertifications.length; i++) {
      if (selectedCertifications[i].skillId == id) {
        selectedCertifications[i].skillLevel = e.target.value;
        break;
      }
    }

    const skillsList = [...filteredCertifications];
    for (let i = 0; i < skillsList.length; i++) {
      let categories = skillsList[i].categories;
      if (categories.length > 0) {
        for (let j = 0; j < categories.length; j++) {
          let skillCategoryId = categories[j].id;
          let skills = categories[j].skills;
          if (skills.length > 0) {
            for (let k = 0; k < skills.length; k++) {
              if (skills[k].skillId == id) {
                if (skillCategoryId == categoryId) {
                  skills[k].skillLevel = e.target.value;
                }
              }
            }
          }
        }
      }
    }
    setFilteredCertifications(skillsList);
  }

  const handleOnChange = (event, option) => {
    var updatedList = [...scategories];
    if (event.target.checked) {
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i].skillId == option.skillId) {
          updatedList[i].isChecked = true;
        }
      }

      const isFound = selectedCertifications.some((element) => {
        if (element.skillId === selectedCertifications.skillId) {
          return true;
        }
        return false;
      });
      if (isFound) {
      } else {
        selectedCertifications.push({
          skillId: option.skillId,
        });
      }
    } else {
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i].skillId == option.skillId) {
          updatedList[i].isChecked = false;
        }
      }

      for (var i = 0; i < selectedCertifications.length; i++) {
        if (selectedCertifications[i].skillId == option.skillId) {
          selectedCertifications.splice(i, 1);
          break;
        }
      }
    }
    setSCategories(updatedList);
  };

  const addCertificationDetails = () => {
    const jobId = window.localStorage.getItem("requestId");

    if (jobId == "") {
      toast.error("Please fill basic info");
      return;
    }

    const certificationData = [];
    selectedCertifications.map((certification) => {
      certificationData.push({
        skillType: "CERTIFICATION",
        skillId: certification.skillId,
        skillLevel: $("#" + certification.skillId + "_skillLevel").val(),
      });
    });

    const certificationSelectedList = [];
    for (let i = 0; i < selectedCertifications.length; i++) {
      if (selectedCertifications[i].skillId != null) {
        certificationSelectedList.push(selectedCertifications[i]);
      } else if (selectedCertifications[i].skillId == null) {
      }
    }

    // const certificationObject = {
    //     skills: certificationData,
    // };

    const certificationObject = {
      skills: certificationSelectedList,
    };

    if (selectedCertifications.length > 0) {
      JobService.saveCertificationService(certificationObject).then(
        (response) => {
          try {
            var requestId = response.data.id;
            if (response.data != null) {
              toast.success("Certifications saved successfully");
              setSCategories([]);
              setModalRight(false);
              getTotalReqCertificationsList();
            }
          } catch (err) {}
        }
      );
    } else {
      toast.error("Please select certifications");
    }
  };

  const searchItems = (searchValue) => {
    setSearchInput(searchValue);
    if (searchValue !== "") {
      if (searchValue.length >= 3) {
        setTreeview(false);
        JobService.searchCertifications(searchValue).then((response) => {
          try {
            if (response.data != null) {
              updateCertifications(response.data.indlist);
            }
          } catch (err) {
            console.log(err);
          }
        });
      } else {
        setTreeview(true);
        updateCertifications(categories);
      }
    } else {
      setTreeview(true);
      updateCertifications(categories);
    }
  };

  const updateCertifications = (certifications) => {
    if (certifications.length > 0) {
      for (let i = 0; i < certifications.length; i++) {
        let categories = certifications[i].categories;
        if (categories.length > 0) {
          for (let j = 0; j < categories.length; j++) {
            let skillCategoryId = categories[j].id;
            let skills = categories[j].skills;
            if (skills.length > 0) {
              for (let k = 0; k < skills.length; k++) {
                var skillId = skills[k].skillId;
                selectedCertifications.length > 0 &&
                  selectedCertifications.map((certification, index) => {
                    var certificationSkillId = certification.skillId;
                    var certificationSkillLevel = certification.skillLevel;
                    var certificationCategoryId = certification.categoryId;
                    if (skillId == certificationSkillId) {
                      if (skillCategoryId == certificationCategoryId) {
                        skills[k].skillLevel = certificationSkillLevel;
                      }
                    }
                  });
              }
            }
          }
        }
      }
      setFilteredCertifications(certifications);
    } else {
      setFilteredCertifications([]);
    }
  };

  const showTreeView = (value) => {
    if (value !== "" && value.length >= 3) return true;
    else return false;
  };
  const onAddCetifications = () => {
    setSelectedCertificationIds([]);
    setModalRight(true);
    setFilteredCertifications(categories);
    setlanguageShow(true);
    setButtonShow(true);
    setSelectedCertifications([]);
    setSelectedSkills([]);
    setTreeview(true);
    resetCertificationDetails(categories);
  };

  const resetCertificationDetails = (categoriesTotalList) => {
    let selectedCertificationsList = [...scategories];
    let categoriesList = [...categoriesTotalList];

    categories.map((industrydetails, index) => {
      industrydetails.categories.length > 0 &&
        industrydetails.categories.map((category, index) => {
          if (category.skills.length > 0) {
            if (selectedCertificationsList.length > 0) {
              selectedCertificationsList.map((sSkill, sIndex) => {
                const isFound = category.skills.some((element) => {
                  if (element.skillId === sSkill.skillId) {
                    return true;
                  }
                  return false;
                });
                if (isFound) {
                  sSkill.categoryId = category.id;
                  let skillLevel = "";
                  if (sSkill.skillLevel !== null) {
                    let skillLevelKey = sSkill.skillLevel.key;
                    skillLevel = skillLevelKey;
                  }

                  category.skills.map((skill) => {
                    skill.isDisabled = false;
                    if (skill.skillId == sSkill.skillId) {
                      skill.skillLevel = skillLevel;
                    }
                  });
                }
              });
            }
            category.skills.map((skill, indexval) => {
              category.skills[indexval].isDisabled = false;
            });
          }
        });
    });
    setFilteredCertifications(categories);
    updatedSelectedCertifications(selectedCertificationsList);
  };

  const updatedSelectedCertifications = (selectedCertificationsList) => {
    if (selectedCertificationsList.length > 0) {
      let certifications = [];
      selectedCertificationsList.map((skill) => {
        let skillId = skill.skillId;
        let categoryId = skill.categoryId;
        let skillLevel = "";
        if (skill.skillLevel !== null) {
          let skillLevelKey = skill.skillLevel.key;
          skillLevel = skillLevelKey;
        }

        let skillType = "";
        if (skill.skillType !== null) {
          let skillTypeKey = skill.skillType.key;
          skillType = skillTypeKey;
        }

        const certificationObj = {
          skillId: skillId,
          skillLevel: skillLevel,
          categoryId: categoryId,
          skillType: skillType,
        };
        certifications.push(certificationObj);
      });
      setSelectedCertifications(certifications);
    }
  };

  const seeFullList = () => {
    setlanguageShow((prev) => !prev);
    setButtonShow((prev) => !prev);
    setFilteredCertifications(categories);
  };

  const handleDeleteSoftSkill = (deletedId, name) => {
    setCertificationId(deletedId);
    setCertificationName(name);
  };

  const removeCertificationDetails = () => {
    JobService.removecertificationsService(certificationId,id).then((response) => {
      toast.success("Certification deleted successfully");
      getTotalReqCertificationsList();
    });
  };

  const checkSkillStatus = (skillId, categoryId) => {
    var isSkillSelected = false;
    if (selectedCertifications.length > 0) {
      for (let i = 0; i < selectedCertifications.length; i++) {
        if (selectedCertifications[i].categoryId == categoryId) {
          if (selectedCertifications[i].skillId == skillId) {
            isSkillSelected = true;
          }
        }
      }
    }
    return isSkillSelected;
  };

  return (
    <div>
      <div className="skill-header">
        <div>
          <div className="profile-card-title"></div>
          <label>
            <strong>
              <h2>Certifications</h2>
            </strong>
          </label>
        </div>
        <div>
          {jobStatus != "CLOSED" && (
            <Button
              id="addCertification"
              color="primary"
              size="sm"
              disabled={
                window.localStorage.getItem("view") === "view" ? true : false
              }
              outline
              onClick={onAddCetifications}
            >
              Add Certifications
            </Button>
          )}
        </div>
      </div>

      <div>
        <Modal
          scrollable={true}
          isOpen={modalRight}
          toggle={() => setModalRight(!modalRight)}
          wrapClassName="modal-right"
          className=" language-model-width"
        >
          <ModalHeader className="mdl_header">
            <div>
              <strong>Select certifications</strong>
            </div>
          </ModalHeader>
          <ModalBody className="labelSize">
            <div className="col-lg-12">
              <Input
                type="text"
                id="search"
                icon="search"
                placeholder="Search for certifications"
                onChange={(e) => searchItems(e.target.value)}
              />
            </div>
            {languageshow &&
              filteredCertifications.length > 0 &&
              filteredCertifications.map((industrydetails, index) => {
                return (
                  <TreeView key={index}
                    nodeLabel={industrydetails.industry}
                    defaultCollapsed={false}
                    className="treeViewIconSize mb-2"
                  >
                    <div className="col">
                      {industrydetails.categories.length > 0 &&
                        industrydetails.categories.map((category, index) => {
                          return (
                            <div key={index}>
                              {category.name == null || category.name == " " ? (
                                <div>
                                  {category.skills.length > 0 &&
                                    category.skills.map((skill, index) => {
                                      return (
                                        <div key={index}>
                                          <div className="col-12">
                                            <div className="row">
                                              <div className="col-sm-6">
                                                <input
                                                  id="certificationId"
                                                  type="checkbox"
                                                  className="input_skill"
                                                  checked={checkSkillStatus(
                                                    skill.skillId,
                                                    category.id
                                                  )}
                                                  onChange={(e) =>
                                                    handleCheck(
                                                      e,
                                                      skill,
                                                      category.id
                                                    )
                                                  }
                                                />
                                                <label
                                                  id="certificationName"
                                                  className="terms"
                                                >
                                                  {" "}
                                                  {skill.name}
                                                </label>
                                              </div>
                                              {checkSkillStatus(
                                                skill.skillId,
                                                category.id
                                              ) ? (
                                                <div className="col-sm-6 mb-2">
                                                  <Input
                                                    width="5"
                                                    type="select"
                                                    id={
                                                      skill.skillId +
                                                      "_skillLevel"
                                                    }
                                                    onChange={(e) =>
                                                      handleSoftSkillLevel(
                                                        e,
                                                        skill.skillId,
                                                        category.id
                                                      )
                                                    }
                                                    value={skill.skillLevel}
                                                  >
                                                    {jobSkillLevels.map(
                                                      ({ value, key }) => (
                                                        <option value={key}>
                                                          {value}
                                                        </option>
                                                      )
                                                    )}
                                                  </Input>
                                                </div>
                                              ) : (
                                                <></>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                              ) : (
                                <div>
                                  <TreeView
                                    nodeLabel={category.name}
                                    defaultCollapsed={false}
                                    className="treeViewIconSize mb-2"
                                  >
                                    <div>
                                      {category.skills.length > 0 &&
                                        category.skills.map((skill, index) => {
                                          return (
                                            <div key={index}>
                                              <div className="col-12">
                                                <div className="row">
                                                  <div className="col-sm-12">
                                                    <label className="terms">
                                                      <input
                                                        id="certification"
                                                        type="checkbox"
                                                        className="input_skill"
                                                        checked={checkSkillStatus(
                                                          skill.skillId,
                                                          category.id
                                                        )}
                                                        onChange={(e) =>
                                                          handleCheck(
                                                            e,
                                                            skill,
                                                            category.id
                                                          )
                                                        }
                                                      />{" "}
                                                      {skill.name}
                                                    </label>
                                                  </div>
                                                  {checkSkillStatus(
                                                    skill.skillId,
                                                    category.id
                                                  ) ? (
                                                    <div className="col-sm-6 mb-2">
                                                      <Input
                                                        width="5"
                                                        type="select"
                                                        id={
                                                          skill.skillId +
                                                          "_skillLevel"
                                                        }
                                                        onChange={(e) =>
                                                          handleSoftSkillLevel(
                                                            e,
                                                            skill.skillId,
                                                            category.id
                                                          )
                                                        }
                                                        value={skill.skillLevel}
                                                      >
                                                        {jobSkillLevels.map(
                                                          ({ value, key }) => (
                                                            <option value={key}>
                                                              {value}
                                                            </option>
                                                          )
                                                        )}
                                                      </Input>
                                                    </div>
                                                  ) : (
                                                    <></>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        })}
                                    </div>
                                  </TreeView>
                                </div>
                              )}
                            </div>
                          );
                        })}
                    </div>
                  </TreeView>
                );
              })}
            {filteredCertifications.length == 0 && (
              <div className="t-nodata mt-4">
                <strong>Certification not found</strong>
              </div>
            )}
          </ModalBody>
          <ModalFooter className="p-4">
            <Button
              id="addDetails"
              color="primary"
              size="sm"
              outline
              onClick={addCertificationDetails}
            >
              Save
            </Button>{" "}
            <Button
              id="modelClose"
              color="primary"
              size="sm"
              outline
              onClick={() => setModalRight(false)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>

      {scategories.length > 0 && (
        <Card className="mt-4 card-margin-button-align">
          <CardBody>
            {scategories.map((skill,index) => {
              return (
                <div key={index} className="col mt-1">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-sm-5">
                        <div className="tracbox">
                          <label>
                            <div className="terms">{skill.name}</div>
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-5">
                        <div className="tracbox">
                          <label>
                            <div id="certificationLevel" className="terms">
                              {skill.skillLevel.value}
                            </div>
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <Row>
                          <div>
                            {jobStatus != "CLOSED" && (
                              <span className="notDisabled ml-2 t-cursor-pointer">
                                  {" "}
                                  <i
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#exampleModalside"
                                    title="Delete Certification"
                                    className="simple-icon-trash edit-copyiconsize arrow-icon-color mr-1 mb-2 emp_icon"
                                    onClick={() =>
                                      handleDeleteSoftSkill(
                                        skill.id,
                                        skill.name
                                      )
                                    }
                                  />
                              </span>
                            )}{" "}
                            <div
                              className="modal fade mt-5"
                              id="exampleModalside"
                              tabIndex="-1"
                              role="dialog"
                              aria-labelledby="exampleModalLabelside"
                              aria-hidden="true"
                            >
                              <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                  <div className="modal-body">
                                    <h3>
                                      Do you want to delete
                                      <strong>
                                        {" " + certificationName + " "}
                                      </strong>{" "}
                                      Certificate?
                                    </h3>
                                  </div>

                                  <div className="modal-footer p-3">
                                    <Button
                                      type="button"
                                      color="primary"
                                      size="sm"
                                      outline
                                      data-dismiss="modal"
                                    >
                                      Close
                                    </Button>
                                    <Button
                                      type="button"
                                      color="primary"
                                      size="sm"
                                      outline
                                      data-dismiss="modal"
                                      onClick={() => {
                                        removeCertificationDetails();
                                      }}
                                    >
                                      Delete
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </CardBody>
        </Card>
      )}
    </div>
  );
};

export default Certification;
